import React from 'react'
import { NavLink } from 'react-router-dom';

function ThankYou() {
    return (
    <div className='vh-70'>
        <div className='container'>
        <div className=''>
        <div className="box-1">
        <div className="col-md-6 text-center">
            <span className="text-dark" style={{fontSize:30, fontWeight:500}}>Thank You for your inquiry!</span><br></br>
            <span className="mt-4" style={{fontSize:20, fontWeight:400}}>An account representative will be in touch within 48 hours by email with more informations.</span><br></br><hr></hr>
            <span className="mt-3 mb-3"style={{fontSize:18, fontWeight:400}}>❓If you have any question in the meantime, please
            <span className="text-info"> <NavLink className="ml-2" to='/Support'>visit our help center.</NavLink> </span></span><br></br>
            <span className="mt-3" style={{fontSize:18, fontWeight:400}}><span><a  href="/Support/CustomerSupport">✅ Refer an organization by contacting us today</a>  </span> and earn $200! when they complete their first order.
            <a type="link" data-toggle="modal" 
            data-target="#exampleModalCenter">
     <span className="text-danger cursor-pointer"><u>Learn more</u></span></a></span>
        </div>
    </div> 
    
 <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered" role="document">
         <div class="modal-content">
             <div class="modal-header">
                 <span class="modal-title" id="exampleModalLongTitle">You can earn $200 by just referring an individual or institution to us</span>
                 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                 <span aria-hidden="true">&times;</span>
                 </button>
             </div>
             <div class="modal-body">
                 <p>
                    When organization or individual successfully processed their first order/trade with us with transaction amount of atleast $5000 or more 
                    we will pay you $200 by Interac using your email address provided by organization or individual as a <strong>referee email</strong> at the time of submitting the transaction.
                    Please make sure your referral include your details in refer by field while submitting sell in Bulk form.
                 </p>
             </div>
        
       </div>
  </div>
</div>
</div>
        </div>
    </div>
        
        
    )
}

export default ThankYou

